module.exports = __webpack_public_path__ + "img/bot_bg.a81d0f91.svg";